import { connect } from "react-redux"

import BulkActionsSubmitButton from "app/static/frontend/search-new/components/BulkActions/buttons/BulkActionsSubmitButton"

import {
    selectBulkActionsSubmitButtonIcon,
    selectBulkActionsSubmitButtonIsDisabled,
    selectBulkActionsSubmitButtonLabel,
    selectBulkActionsSubmitButtonSwalButtons,
    selectBulkActionsSubmitButtonSwalText,
    selectBulkActionsSubmitButtonSwalTitle,
} from "shared/search/searchify/bulkactions/selectors"

const mapStateToProps = (state, props) => ({
    submitButtonIcon: selectBulkActionsSubmitButtonIcon(state, props),
    submitButtonIsDisabled: selectBulkActionsSubmitButtonIsDisabled(state, props),
    submitButtonLabel: selectBulkActionsSubmitButtonLabel(state, props),
    submitButtonSwalButtons: selectBulkActionsSubmitButtonSwalButtons(state, props),
    submitButtonSwalText: selectBulkActionsSubmitButtonSwalText(state, props),
    submitButtonSwalTitle: selectBulkActionsSubmitButtonSwalTitle(state, props),
})

export default connect(mapStateToProps, null)(BulkActionsSubmitButton)
